var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "padding-right": "10px",
        display: "inline-block",
        "vertical-align": "middle"
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-content": "center",
                "padding-left": "5px"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Insurance.Premium")))]
          ),
          _vm._l(_vm.dataProvider, function(item, index) {
            return _c("div", { key: index }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-content": "center",
                    "padding-left": "5px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "13px",
                        "text-decoration": "none"
                      }
                    },
                    [_vm._v(_vm._s(item.currency + ": "))]
                  ),
                  _c("span", { style: _vm.style }, [
                    _vm._v(_vm._s(item.amount))
                  ])
                ]
              )
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }